import { Delete as DeleteIcon } from "@mui/icons-material";
import { Grid, IconButton } from "@mui/material";
import type { FC } from "react";
import { Select } from "../../components/select/Select";
import type { ID } from "../../data/BaseEntity";

const DeleteOptionButton: FC<{ onDelete: () => void }> = ({ onDelete }) => (
  <IconButton color="secondary" onClick={onDelete} aria-label="Usuń opcję">
    <DeleteIcon />
  </IconButton>
);

interface Option {
  readonly value: string;
  readonly label: string;
}

interface Props {
  readonly options: Option[];
  readonly value: ID | null;
  readonly onChange: (value: ID) => void;
  readonly onDelete: () => void;
}

const ProductOption: FC<Props> = ({ value, options, onChange, onDelete }) => (
  <Grid container>
    <Grid size={9}>
      <Select
        label="Opcja"
        size="small"
        fullWidth
        values={options}
        value={value ?? ""}
        onSelect={(id) => onChange(id)}
      />
    </Grid>
    <Grid size={3}>
      <DeleteOptionButton onDelete={onDelete} />
    </Grid>
  </Grid>
);

export default ProductOption;
